import { JetView } from 'webix-jet';
import { allpayments } from 'models/allpayments';
import { devConfig } from 'config/config';

/**
 * Class representing a view for the record table with profile options.
 * @extends JetView
 */
export default class recordTablePerfilOpcionesView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable',
            select: true, // Enables row selection
            columns: [
                {
                    id: 'package',
                    header: _('dav'), // Header text from localization
                    fillspace: 2, // Fills available space
                    minWidth: 100,
                    sort: 'text', // Sort by text
                    format: dateFormat, // Format for date display
                },
                {
                    id: 'maintainer',
                    header: _('ID Usuario'), // Header text from localization
                    width: 100,
                    sort: 'int', // Sort by integer
                },
                {
                    id: 'architecture',
                    header: _('Transacción ID'), // Header text from localization
                    width: 100,
                    sort: 'int', // Sort by integer
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'es/GetPerfilOpciones', // API endpoint for data
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        // Event listener for filtering data based on profile options
        this.on(this.app, 'perfilOpciones:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for filters
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date to query
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add formatted start date
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add formatted end date
                                    }
                                }
                            }
                        }
                    }
                }
            }
            console.log(string1); // Log the constructed query string
            grid.load(grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
        });

        // Event listener for loading data based on user ID
        this.on(this.app, 'user:id', (Id) => {
            grid.load(grid.data.url + '?id=' + Id); // Load data for specific user ID
        });
    }
}

// FILE DOCUMENTED
